import {
  pageInfo,
  initPage,
  saveData,
  initUpdate,
  editData,
  deleteData,
  exportData,
  printUploadSubmit,
  podShow,
  fileDownload,
  doPrint,
  initBusinessType,
  uploadGatePassSubmit,
  selectFileInfo,
  selectGatepassInfo,
  deleteFileInfo,
  boxUpload,
  templateZpc
} from './../api';
import {selectOrderStatus,selectOrderType,selectBoxCondition} from "../../../../api";
const printShipOrder = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    printSubmitResp:null,
    podShowRes: null,
    fileObj: null,
    printResp: null,
    orderStatusObj: null,
    orderTypeObj: null,
    boxConditionTypeObj: null,
    initBusinessTypeObj:null,
    printGatepassSubmitResp:null,
    invoiceDataResp: null,
    gatepassDataResp: null,
    deleteData: null,
    boxUplaodResp:null,
    templateZpcObj:null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [item.isInternationalOrder != 'Y',true,true] }));
      state.total = data.total;
      //state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PRINT_UPLOAD_SUBMIT(state, data) {
      state.printSubmitResp = data;
    },
    POD_SHOW(state, data) {
      state.podShowRes = data;
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    DO_PRINT(state,data){
      state.printResp = data;
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDER_TYPE(state,data){
      state.orderTypeObj = data.obj || {};
    },
    BOXCONDITION_TYPE(state,data){
      state.boxConditionTypeObj = data.obj || {};
    },
    INIT_BUSINESS_TYPE(state,data) {
      state.initBusinessTypeObj = data.obj || {};
    },
    YARD_PRINT_GATEPASS(state, data) {
      state.printGatepassSubmitResp = data;
    },
    YARD_INVOICE_DATA(state, data) {
      state.invoiceDataResp = data || {};
    },
    YARD_GATEPASS_DATA(state, data) {
      state.gatepassDataResp = data || {};
    },
    DELETE_FILE_DATA(state, data) {
      state.deleteData = data || {};
    },

    YARD_BOX_UPLOAD(state, data) {
      state.boxUplaodResp = data || {};
    },
    DOWNLOAD_TEMPLATEZPC(state, data) {
      state.templateZpcObj = data;
    },
  },

  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //订单回单上传
    async printUploadSubmit({ commit }, obj) {
      let resp = await printUploadSubmit(obj);
      commit('PRINT_UPLOAD_SUBMIT', resp);
    },
    //回单预览
    async podShow({ commit }, obj) {
      let resp = await podShow(obj);
      commit('POD_SHOW', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    //发货单打印记录打印操作
    async doPrint({commit}, obj){
      let resp = await doPrint(obj);
      commit('DO_PRINT', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    async selectBoxCondition({commit}, obj){
      let resp = await selectBoxCondition(obj);
      commit('BOXCONDITION_TYPE', resp);
    },
    //初始化编辑产品类型事件
    async initBusinessType({commit}, obj){
      let resp = await initBusinessType(obj);
      commit('INIT_BUSINESS_TYPE', resp);
    },
    //gatePass回单上传
    async uploadGatePassSubmit({ commit }, obj) {
      let resp = await uploadGatePassSubmit(obj);
      commit('YARD_PRINT_GATEPASS', resp);
    },
    //查询发货单
    async selectFileInfo({ commit }, obj) {
      let resp = await selectFileInfo(obj);
      commit('YARD_INVOICE_DATA', resp);
    },
    //查询gatepass
    async selectGatepassInfo({ commit }, obj) {
      let resp = await selectGatepassInfo(obj);
      commit('YARD_GATEPASS_DATA', resp);
    },
    //删除文件数据
    async deleteFileInfo({ commit }, obj) {
      let resp = await deleteFileInfo(obj);
      commit('DELETE_FILE_DATA', resp);
    },

    async boxUpload({ commit }, obj) {
      let resp = await boxUpload(obj);
      commit('YARD_BOX_UPLOAD', resp);
    },

    //下载订单模板
    async templateZpc({ commit }, obj) {
      let resp = await templateZpc(obj);
      commit('DOWNLOAD_TEMPLATEZPC', resp);
    },
}
}
export default printShipOrder



// WEBPACK FOOTER //
// ./src/page/yard/printShipOrder/store/printShipOrder.store.js